import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { sendGetRequest } from "../../../../actions/app-actions";
import Loader from "../../../../components/Loader/Loader";
import { Modal, ModalBody } from "reactstrap";
import moment from "moment";
import { getLoggedInUserTimezone, toUserTime } from "../../../../utils/utility";
import { formatBookingDate } from "./formatBookingDate";
import "./scheduledEvents.scss";

const DetailItem = ({ label, value, wide = false }) => {
  if (value === null || value === undefined || String(value).trim() === "") {
    return null;
  }
  return (
    <div className={`se-details__item${wide ? " se-details__item--wide" : ""}`}>
      <dt>{label}</dt>
      <dd>{value}</dd>
    </div>
  );
};

const PendingViewDetailsModal = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    const { eventId, sendGetRequest } = props;

    setIsLoading(true);

    sendGetRequest({
      url: `admin/adhoc/${eventId}`,
      onSuccess: function (response) {
        setData(response.event);
        setIsLoading(false);
      },
      onError: function () {
        setIsLoading(false);
      },
    });
  }, []);

  const expireLabel = data
    ? formatBookingDate(
        moment(data.created_at, "YYYY-MM-DD")
          .add(data.link_expiration_period, "days")
          .format("YYYY-MM-DD"),
        "YYYY-MM-DD"
      )
    : "";

  return (
    <>
      <Loader isShowLoader={isLoading} />
      <Modal
        returnFocusAfterClose
        isOpen={props.showViewDetailModal && !isLoading}
        toggle={props.handleClose}
        centered
        className="se-details-modal"
        contentClassName="se-details-modal__content"
      >
        <ModalBody>
          {data ? (
            <div className="se-details">
              <header className="se-details__header">
                <div className="se-details__header-copy">
                  <p className="se-details__eyebrow">Pending event</p>
                  <h2>{data.event_name}</h2>
                  {data.event_duration_in_minutes ? (
                    <span className="se-details__slot">
                      {data.event_duration_in_minutes} minutes
                    </span>
                  ) : null}
                </div>
                <button
                  type="button"
                  className="se-details__close"
                  onClick={props.handleClose}
                  aria-label="Close"
                >
                  ×
                </button>
              </header>

              <dl className="se-details__grid">
                <DetailItem label="Event title" value={data.event_name} />
                <DetailItem label="Venue" value={data?.venue?.venue} />
                <DetailItem
                  label="Duration"
                  value={
                    data.event_duration_in_minutes
                      ? `${data.event_duration_in_minutes} minutes`
                      : null
                  }
                />
                <DetailItem label="Expires on" value={expireLabel} />
              </dl>

              {(data.adhoc_dates || []).length > 0 ? (
                <div className="se-details__slots">
                  <h3>Selected slots</h3>
                  {data.adhoc_dates.map((adhocDate, index) => (
                    <Fragment key={index}>
                      <p className="se-details__slot-day">
                        {formatBookingDate(adhocDate.dated, "YYYY-MM-DD")}
                      </p>
                      <div className="se-details__slot-list">
                        {(adhocDate.availabilities || []).map(
                          (availability, innerIndex) => (
                            <span
                              key={innerIndex}
                              className="se-details__slot-chip"
                            >
                              {toUserTime(
                                availability.start_time,
                                getLoggedInUserTimezone(),
                                "HH:mm:ss",
                                "HH:mm"
                              )}
                            </span>
                          )
                        )}
                      </div>
                    </Fragment>
                  ))}
                </div>
              ) : null}
            </div>
          ) : null}
        </ModalBody>
      </Modal>
    </>
  );
};

export default connect(null, {
  sendGetRequest,
})(PendingViewDetailsModal);
